export const environment = {
  production: false,
  featureScope: "LA",
  keycloakBaseUrl: 'https://sso.preprod.services.utimaco.com',
  keycloakRealm: 'Utimaco-Portal-PREPROD',
  keycloakClientId: 'TaasPortalFrontend',
  restApiBasePath: 'https://portal-api.preprod.services.utimaco.com/api/v1/',
  dmsUrl: 'https://dms.preprod.services.utimaco.com',
  marketplaceUrl: 'https://marketplace.preprod.services.utimaco.com',
  frontendUrls: [
    {
      productTypes: ['General Purpose HSM as a Service', 'Payment HSM as a Service'],
      frontendUrl: 'https://stage.portal.myhsm.com/'
    },
    {
      productTypes: ['EKM as a Service'],
      frontendUrl: 'https://ekmaas.preprod.services.utimaco.com/'
    },
    {
      productTypes: ['Timestamp as a Service'],
      frontendUrl: 'https://timestamp.preprod.services.utimaco.com/'
    },
    {
      productTypes: ['File and Folder Encryption as a Service'],
      frontendUrl: 'https://portal.lancrypt.com/'
    },
    {
      productTypes: ['eInvoice Signature as a Service'],
      //TODO add URL once provided in TUP-169
      frontendUrl: ''
    },
    {
      productTypes: ['POS Key Generation aaS'],
      //TODO add URL once provided in TUP-169
      frontendUrl: ''
    },
  ]
};